// Una pagina è consentita se il suo percorso non appartiene a nessuna sezione, oppure appartiene a una sezione
// dell'utente. `tutte`: tutte le sezioni (da /sezioni); `mie`: gli id delle sezioni dell'utente.
// Controllo solo di navigazione: i dati li protegge il BE.
export function percorsoConsentito (pathname, tutte, mie) {
  if (!tutte) return true
  const sezione = tutte.find(s => pathname === s.path || pathname.startsWith(`${s.path}/`))
  return !sezione || (mie || []).includes(sezione._id)
}
